import styled from '@emotion/styled';

const ToolTipName = styled.div`
  font-size: 14px;
  font-weight: 500;
`;
const ToolTipContent = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: var(--dk-text-dim, #b7bbc2);
`;

export { ToolTipName, ToolTipContent };
